export var ACTIONS = /*#__PURE__*/function (ACTIONS) {
  ACTIONS[ACTIONS["FOCUS_BY_LOCALID"] = 0] = "FOCUS_BY_LOCALID";
  return ACTIONS;
}({});